/**
 * Minimal click-to-expand lightbox for OOC embedded images. The overlay
 * is created once, lazily, and reused. Closing on backdrop click or Esc.
 */
let overlay: HTMLDivElement | null = null;
let overlayImg: HTMLImageElement | null = null;

function ensureOverlay(): void {
  if (overlay) return;
  overlay = document.createElement("div");
  overlay.id = "ooc_lightbox";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");

  overlayImg = document.createElement("img");
  overlayImg.id = "ooc_lightbox_img";
  overlayImg.alt = "expanded image";
  overlay.appendChild(overlayImg);

  overlay.addEventListener("click", hideLightbox);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideLightbox();
  });
  document.body.appendChild(overlay);
}

export function showLightbox(src: string): void {
  ensureOverlay();
  if (!overlay || !overlayImg) return;
  overlayImg.src = src;
  overlay.style.display = "flex";
}

export function hideLightbox(): void {
  if (!overlay || !overlayImg) return;
  overlay.style.display = "none";
  overlayImg.src = "";
}
